import type { ComponentProps } from 'react'

import {
  autocompleteClasses,
  formControlLabelClasses,
  checkboxClasses,
  inputBaseClasses,
  outlinedInputClasses,
  svgIconClasses,
  IconButton,
  CSSObject,
  styled,
  Checkbox as CheckboxBase,
  FormControlLabel as FormControlLabelBase,
} from '@mui/material'

export const Container = styled('div')<{ inputWrapper?: boolean }>(({ theme, inputWrapper }) => ({
  backgroundColor: theme.palette.common.white,
  padding: inputWrapper ? theme.spacing(0, 0, 1.5) : theme.spacing(1.5, 2),
  display: 'flex',
  justifyContent: 'space-between',

  '&:not(:first-of-type)': {
    borderTop: `0.5px solid ${theme.palette.grey[300]}`,
  },
}))

const StyledCheckbox = styled(CheckboxBase)(({ theme }) => ({
  paddingRight: 0,
  marginRight: theme.spacing(2),
  width: theme.spacing(3),
  height: theme.spacing(3),

  [`&.${checkboxClasses.root}`]: {
    paddingRight: 0,

    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
}))

export const Checkbox = (props: ComponentProps<typeof CheckboxBase>) => {
  const { color = 'primary', ...rest } = props

  return <StyledCheckbox color={color} {...rest} />
}

export const FormControlLabel = styled(FormControlLabelBase)(({ theme }) => ({
  margin: 0,
  width: '100%',

  [`& .${formControlLabelClasses.label}`]: {
    flex: 1,
    color: theme.palette.grey[800],
  },
}))

export const CustomInput = styled('input')(({ theme }) => ({
  border: 'none',
  color: theme.palette.grey[800],
  ...(theme.typography['Lato Body 1'] as CSSObject),
  width: '100%',
  padding: 0,
  paddingTop: 8,
  paddingBottom: 8,
  marginTop: -8,
  marginBottom: -8,

  '&:focus': {
    outline: 'none',
  },
}))

export const AutocompleteWrapper = styled('div')(({ theme }) => ({
  width: '100%',

  [`'& .${autocompleteClasses.root}'`]: {
    width: '100%',
  },

  [`& div.${inputBaseClasses.root}`]: {
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    paddingTop: 26,
  },

  [`.${outlinedInputClasses.root}`]: {
    padding: theme.spacing(1),
  },

  [`& ${inputBaseClasses.input}`]: {
    flexGrow: 1,
    width: 0,
    minWidth: 50,
    paddingTop: 0,
    marginBottom: 8,
  },
}))

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  width: 30,
  height: 30,
  marginTop: -3,
  marginBottom: -3,

  [`& .${svgIconClasses.root}`]: {
    width: 20,
    height: 20,
    color: theme.palette.grey[800],
  },
}))
